import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function requiredIfAllEmpty(requiredIf: { value: AbstractControl[] }): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.toString().trim();
    
    const hasOtherValue = requiredIf.value.some((ctrl: AbstractControl) => {
      return ctrl.value && ctrl.value.toString().trim();
    });

    if (value || hasOtherValue) {
      return null;
    }

    return {
      requiredIfAllEmpty: true
    };
  };
}
